'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, domAnimation, LazyMotion, m, useReducedMotion } from 'motion/react';
import { useTranslations } from 'next-intl';
import { DataTable } from '@/components/ui/data-table';
import { Panel } from '@/components/ui/panel';
import { getProfileHref } from '@/lib/profile/profile-href';
import { useUserProfilePrefetchIntent } from '@/lib/sdk/prefetch';
import { MarketBoosterRowCells } from './market-booster-row-cells';
import type { MarketBoosterLeaderboardEntry, MarketBoosterSortValue } from './types';
const NOOP_SORT = (): void => {};
const VISIBLE = {
  opacity: 1,
  y: 0
} as const;
const ENTER_OFFSET = {
  opacity: 0,
  y: 16
} as const;
const TRANSITION = {
  duration: 0.2,
  ease: [0.16, 1, 0.3, 1]
} as const;
interface MarketYourBoosterCardProps {
  entry: MarketBoosterLeaderboardEntry;
  userId: string;
  sortBy: MarketBoosterSortValue;
  visible: boolean;
}
export function MarketYourBoosterCard(t0) {
  const $ = _c(10);
  const {
    entry,
    userId,
    sortBy,
    visible
  } = t0;
  const t = useTranslations("market.boosters");
  const intent = useUserProfilePrefetchIntent(userId);
  const reduceMotion = useReducedMotion() === true;
  let t1;
  if ($[0] !== entry || $[1] !== intent || $[2] !== reduceMotion || $[3] !== sortBy || $[4] !== t || $[5] !== userId || $[6] !== visible) {
    t1 = visible ? <m.div initial={reduceMotion ? false : ENTER_OFFSET} animate={VISIBLE} exit={reduceMotion ? VISIBLE : ENTER_OFFSET} transition={reduceMotion ? {
      duration: 0
    } : TRANSITION} className="pointer-events-none absolute inset-x-0 bottom-0 z-overlay"><Panel inheritBackground={true} tone="accent" density="compact" className="pointer-events-auto overflow-hidden rounded-control border border-border-primary bg-background-secondary/70 py-0! shadow-elevation-sticky supports-backdrop-filter:backdrop-blur-xl [&_a]:bg-transparent [&_tr]:bg-transparent"><DataTable entries={[entry]} sortBy={sortBy} sortOrder="desc" onSortChange={NOOP_SORT} onSortOrderChange={NOOP_SORT} panel="borderless"><DataTable.Body>{row => <DataTable.Row key={row.participationId} href={getProfileHref(userId)} intent={intent} ariaLabel={t("row_aria_label", {
              name: row.booster.displayName ?? row.booster.handle ?? "",
              rank: row.rank,
              amount: row.totalAmount,
              count: row.numBoosts
            })} data-testid="market-your-booster-row" className="hover:bg-transparent! hover:shadow-none! [&>td]:bg-transparent!"><MarketBoosterRowCells entry={row} isUser={true} /></DataTable.Row>}</DataTable.Body></DataTable></Panel></m.div> : null;
    $[0] = entry;
    $[1] = intent;
    $[2] = reduceMotion;
    $[3] = sortBy;
    $[4] = t;
    $[5] = userId;
    $[6] = visible;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <LazyMotion features={domAnimation}><AnimatePresence initial={false}>{t1}</AnimatePresence></LazyMotion>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}